'use client';
import { Button } from '@heroui/react';
import { useTranslations } from 'next-intl';
import React, { useState } from 'react';

const aboutInfo = (t: (key: string) => string) => [
  {
    id: 1,
    title: t('paragraphOne.title'),
    text: t('paragraphOne.bodyText'),
  },
  {
    id: 2,
    title: t('paragraphTwo.title'),
    text: t('paragraphTwo.bodyText'),
  },
  {
    id: 3,
    title: t('paragraphThree.title'),
    text: t('paragraphThree.bodyText'),
  },
  {
    id: 4,
    title: t('paragraphFour.title'),
    text: t('paragraphFour.bodyText'),
  },
];

export default function AboutHeldenstrom() {
  const [selected, setSelected] = useState(1);
  const t = useTranslations('home.about');

  return (
    <section className="bg-primary w-full">
      <div className="px-6 py-8 md:py-16 max-w-[1512px] mx-auto w-full">
        <h2 className="pb-8 md:pb-12">{t('title')}</h2>

        <div className="flex flex-col gap-4 md:gap-10 md:flex-row mx-auto max-w-[1200px] justify-around">
          <div className="flex flex-col flex-1">
            {aboutInfo(t).map((info) => (
              <Button
                disableRipple
                key={info.id}
                size="lg"
                className={`${info.id == selected ? 'bg-white' : 'bg-transparent'} p-4 rounded-[40px] font-bitter font-semibold whitespace-normal text-center md:text-start w-fit transition-colors duration-200 ease-linear`}
                onPress={() => setSelected(info.id)}
              >
                {info.title}
              </Button>
            ))}
          </div>
          <div className="flex flex-col flex-1">
            <p className="bg-white p-6 md:p-12 rounded-3xl shadow-[0_4px_4px_rgba(0,0,0,0.25)] min-h-full content-center">
              {aboutInfo(t).find((info) => info.id == selected)?.text}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
